import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fa5, faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import AddStaffModal from "./AddArea";
import { getAllArea, getAllStaff } from "../../CrudOperations/GetOperation";
import AddArea from "./AddArea";
import { useLocation } from "react-router-dom";

const ManageArea = () => {
  
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [Staff, setStaff] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredAreaList, setFilteredAreaList] = useState([]);
  const [AreaList, setAreaList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [currentStaffId, setCurrentStaffId] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [edit, setEdit] = useState("");
  const [AreaDeputationSkillNames, setAreaDeputationSkillNames] = useState("");
const location = useLocation();
const passedAreas = location?.state?.areaList || null;

useEffect(() => {
  const fetchAreas = async () => {
    if (passedAreas) {
      setAreaList(passedAreas);
      setFilteredAreaList(passedAreas);
      return;
    }

    const response = await getAllArea();
    if (response.data.Message === "Success") {
      setAreaList(response.data.Data);
      setFilteredAreaList(response.data.Data);
    }
  };

  fetchAreas();
}, []);


  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredList = AreaList.filter((p) =>
      p.AreaName.toLowerCase().includes(query)
    );
    setFilteredAreaList(filteredList);
  };

  const handleAddStaff = async (e) => {
    e.preventDefault();
    if (Staff) {
      const response = await AddStaff({ Staff });
      if (response.data.message === "Staff saved successfully!") {
        const newStaff = { Staff, id: response.data.data.id };
        setAreaList([...AreaList, newStaff]);
        setFilteredAreaList([...filteredAreaList, newStaff]);
        setStaff("");
        toast.success("Staff added successfully!");
      } else {
        toast.error("Failed to add Staff. Please try again.");
      }
    } else {
      toast.error("Please enter a valid Staff.");
    }
  };

  // handleUpdateStaff

  const handleUpdateStaff = async (p) => {
    setEdit(p);

    setIsModalOpen(true);
  };

  const handleAddStaffformClick = () => {
// if we make a breakpoint here,, modal should not open due to execution stop here//.. bt model opens.. why
   setTimeout(() => {
    setIsModalOpen(true); // ⏱️ delay state change
  }, 1000); // 1 second delay so you can pause
  };

  const closeModal = () => {
    setEdit("");
    setIsModalOpen(false);
  };

  const handleSubmit = async () => {
    const response = await getAllArea();
    console.log(response);

    if (response.data.Message === "Success") {
      setAreaList(response.data.Data);
      setFilteredAreaList(response.data.Data);

      setEdit("");

      setIsModalOpen(false); // Close the modal after adding
      toast.success("Staff added successfully!");
    }
  };

  const handleUpdate = (newStaff) => {
    console.log("Updated Staff:", newStaff);
    console.log("Editing Staff ID:", edit.id);
    console.log("Staff List:", AreaList);

    setAreaList((prev) =>
      prev.map((prevStaff) =>
        prevStaff.id === edit.id
          ? {
              ...prevStaff, // Keep existing properties
              ...newStaff, // Merge properties from newStaff
            }
          : prevStaff
      )
    );

    setFilteredAreaList((prev) =>
      prev.map((prevStaff) =>
        prevStaff.id === edit.id
          ? {
              ...prevStaff,
              ...newStaff,
            }
          : prevStaff
      )
    );

    setEdit(null);
    closeModal(); // Close the modal after updating
  };

  const handleFilterChange = (e) => {
    const selectedStatus = e.target.value;

    if (!selectedStatus) {
      setFilteredAreaList(AreaList);
      return;
    }

    const filteredList = AreaList.filter(
      (item) => item.Status === selectedStatus
    );
    setFilteredAreaList(filteredList);
  };

  return (
    <div className="container mx-auto p-8 bg-white rounded-lg shadow-lg shadow-gray-300">
      <h1 className="text-xl font-inter font-bold mb-6 border-b-4 border-blue-600 pb-2 text-gray-800">
        Manage Area
      </h1>

      <div className="mb-6 flex justify-between items-center">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInput}
          className="w-1/2 border border-gray-300 p-3 rounded-md transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        />

        <div className="flex items-center gap-4">
          <button
            onClick={handleAddStaffformClick}
            className="bg-blue-600 text-white px-6 py-2 rounded-md flex items-center gap-2 transition-transform duration-200 hover:bg-blue-700 hover:scale-105 shadow-md shadow-blue-500 hover:shadow-lg"
          >
            <FontAwesomeIcon icon={faPlus} />
            Add Area
          </button>
        </div>
      </div>

      {/* Responsive table wrapper */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white table-auto border border-gray-300 rounded-lg shadow-sm">
          <thead className="bg-gray-100">
            <tr>
              {[
                "S.No",
                 "Event Name",
                "Block",
                "District",
                "State",
                "Pincode",
                "LandMark",
                "NoOfDeputation",
                "Skills",
                "Status",
                "Edit",
              ].map((heading) => (
                <th
                  key={heading}
                  className="py-3 px-4 text-center font-semibold text-gray-700"
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {console.log(filteredAreaList)
            }
            {filteredAreaList.length > 0 ? (
              filteredAreaList.map((p, index) => (
                <tr
                  key={index}
                  className="border-b transition-colors duration-200 hover:bg-gray-50"
                >
                  <td className="py-3 px-4 text-center">{index + 1}</td>
                           <td className="py-3 px-4 text-center">
                    {p.EventDetailName || "N/A"}
                  </td>
                  <td className="py-3 px-4 text-center">{p.AreaName}</td>
                  <td className="py-3 px-4 text-center">
                    {p.DistrictName || "N/A"}
                  </td>
                  <td className="py-3 px-4 text-center">
                    {p.StateName || "N/A"}
                  </td>
                  <td className="py-3 px-4 text-center">
                    {p.Pincode || "N/A"}
                  </td>
                  <td className="py-3 px-4 text-center">
                    {p.LandMark || "N/A"}
                  </td>
                  <td className="py-3 px-4 text-center">
                    {p.NoOfDeputation || "N/A"}
                  </td>
                  <td
                    className="py-3 px-4 text-center cursor-pointer text-red-500 hover:bg-gray-100"
                    onClick={() => {
                      setIsOpen(true);
                      setAreaDeputationSkillNames(p.AreaDeputationSkills);
                    }}
                  >
                    View
                  </td>
                  <td className="py-3 px-4 text-center">
                    {p.Status === 0 ? "InActive" : "Active"}
                  </td>

                  <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleUpdateStaff(p)}
                      className="text-blue-500 transition-colors duration-200 hover:text-blue-700"
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                  </td>

                  {/* <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleDeleteStaff(p.id)}
                      className="text-red-500 transition-colors duration-200 hover:text-red-700"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="py-3 text-center text-gray-600">
                  No Staffs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-md w-96 shadow-lg relative">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-black"
              onClick={() => setIsOpen(false)}
            >
              &times;
            </button>

            <div className="text-gray-800 bg-white p-6 rounded-xl shadow-xl max-w-md mx-auto">
              <h1 className="text-lg font-semibold text-blue-700 mb-4 flex items-center gap-2 border-b pb-2">
                <svg
                  className="w-5 h-5 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16 7a4 4 0 01.88 7.903A5.5 5.5 0 1111.097 8.12 4.002 4.002 0 0116 7z"
                  />
                </svg>
                Required Skills
              </h1>

              {AreaDeputationSkillNames &&
              AreaDeputationSkillNames.length > 0 ? (
                <div className="flex flex-wrap gap-2">
                  {AreaDeputationSkillNames.map((skill, index) => (
                    <span
                      key={skill.SkillId}
                      className="inline-block bg-gradient-to-r from-blue-100 to-blue-200 text-blue-900 text-sm font-medium px-4 py-1.5 rounded-full shadow-sm hover:from-blue-200 hover:to-blue-300 transition-all duration-300"
                    >
                      {skill.SkillName}
                    </span>
                  ))}
                </div>
              ) : (
                <p className="text-red-500">No skills available</p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Add Staff Modal */}
      {isModalOpen && (
        <AddArea closeModal={closeModal} onSubmit={handleSubmit} Area={edit} />
      )}
    </div>
  );
};

export default ManageArea;
